import {InjectionToken} from "@angular/core"

export const CM_COLORMASS_CLIENT = new InjectionToken<string>("colormass.client")
